import FlashVersion from "javascripts/flash_version";
import ConnectionAdapter from './connection_adapter';
import { VidioHelpers } from 'shared/vidio_helpers';
import Uap from "./uap/uap";

export default class PlayerEnvironment {
  static flashVersion() {
    return (this._flashVersion = (this._flashVersion || (new FlashVersion()).get()));
  }

  static uaParser(){
    this._uaParser = this._uaParser || new Uap();
    return this._uaParser;
  }

  static browserName(){
    return this.uaParser().getBrowser().name;
  }

  static browserVersion(){
    return this.uaParser().getBrowser().version;
  }

  static osName(){
    return this.uaParser().getOS().name;
  }

  static osVersion(){
    return this.uaParser().getOS().version;
  }

  static deviceModel(){
    return this.uaParser().getDevice().model;
  }

  static deviceVendor(){
    return this.uaParser().getDevice().vendor;
  }

  static platform(){
    return VidioHelpers.getPlatform();
  }

  static embed(){
    return VidioHelpers.isEmbedVideo();
  }

  static referrer(){
    return document.referrer;
  }

  static currentEnv(){
    return {
      flash_version: this.flashVersion(),
      browser_name: this.browserName(),
      browser_version: this.browserVersion(),
      os_name: this.osName(),
      os_version: this.osVersion(),
      device_model: this.deviceModel(),
      device_vendor: this.deviceVendor(),
      platform: this.platform(),
      embed: this.embed(),
      referrer: this.referrer(),
      app_name: 'vidio',
      lite_mode: ConnectionAdapter.liteModeEnabled()
    };
  }

  static withVideoJsEnv(properties){
    var videoJsInfo = {
      player_name: 'videojs',
      player_version: window.videojs.VERSION
    };
    return Object.assign(properties, videoJsInfo, this.currentEnv());
  }
}
